import namespace from '@/helpers/namespace'

export default namespace('map', {
  getters: [
    'longitude',
    'latitude'
  ],
  actions: [

  ],
  mutations: [
    'setLongitude',
    'setLatitude'
  ]
})
